{
	"dateInfoNotAvailable": "Visualização não disponível",
	"monthDays": "Total de {{monthDays}} dias"
}
